import {Directive, Renderer, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[assignment-status]'
})
export class AssignmentStatusDirective {

  @Input('status') status;

  constructor(private el: ElementRef,
              private renderer: Renderer,) {
    setTimeout(() => {
      this.check();
    }, 0);
  }


  check() {
    var addClass = "";
    var status = "";
    this.status = +this.status;
    if(this.status == 1 || !this.status){
      addClass = "badge-primary";
      status= " Open ";
    }else if(this.status == 2){
      addClass = "badge-warning";
      status= " Progress  ";
    }
    else if(this.status == 3){
      addClass = "badge-success";
      status= " Completed ";
    }

    if(addClass != '' && status != ""){
      var d1 = this.el.nativeElement;
      d1.insertAdjacentHTML('beforeend', '<span class="text-white ">' + status + '</span>');
      this.renderer.setElementClass(this.el.nativeElement,"badge",true);
      this.renderer.setElementClass(this.el.nativeElement,"badge-pill",true);
      this.renderer.setElementClass(this.el.nativeElement,addClass,true);
    }
  }
}

export const AssignmentStatusDirective_DIRECTIVES = [
  AssignmentStatusDirective
];



// WEBPACK FOOTER //
// /app/src/app/directives/assignment-status/assignment-status.directive.ts